// Notification Utilities - Centralized notification handling using Sonner toast

import { toast } from 'sonner';

export interface NotificationOptions {
	title?: string;
	message: string;
	type?: 'success' | 'error' | 'info' | 'warning';
}

export const notificationUtils = {
	success: (message: string, title?: string) => {
		if (title) {
			toast.success(title, { description: message });
		} else {
			toast.success(message);
		}
	},

	error: (message: string, title?: string) => {
		if (title) {
			toast.error(title, { description: message });
		} else {
			toast.error(message);
		}
	},

	info: (message: string, title?: string) => {
		if (title) {
			toast.info(title, { description: message });
		} else {
			toast.info(message);
		}
	},

	warning: (message: string, title?: string) => {
		if (title) {
			toast.warning(title, { description: message });
		} else {
			toast.warning(message);
		}
	},

	// Generic notification with custom options
	show: ({ title, message, type = 'info' }: NotificationOptions) => {
		const toastMethod = {
			success: toast.success,
			error: toast.error,
			info: toast.info,
			warning: toast.warning,
		}[type];

		if (title) {
			toastMethod(title, { description: message });
		} else {
			toastMethod(message);
		}
	},
};
